import TYPES from '@/modules/shared/types';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';
import { CalendlyRepository } from '../../domain/repository/calendly-repository';
import { SingleUseScheduleLinkEntity } from '../../domain/entities/single-use-schedule-link-entity';

@Injectable()
export default class CalendlyHttpRepository implements CalendlyRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/calendly/single-use-schedule-link/`;

  get(): Promise<SingleUseScheduleLinkEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
